<template>
  <transition name="page"
              mode="out-in">
    <component :is="layout">

    </component>
  </transition>
</template>

<script>
import {mapGetters} from 'vuex';
const defaultLayout = 'admin';
const {appName} = window.config;

export default {
  metaInfo() {
    return {
      title: this.$route.meta && this.$route.meta.title ? this.$route.meta.title : appName,
      titleTemplate: `%s · ${appName}`
    }
  },
  computed: {
    ...mapGetters([
      'authenticated',
      'user',
      'team',
    ]),
    layout() {
      return (this.$route.meta.layout || defaultLayout) + '-layout';
    },
  },
}
</script>
